// extracted by mini-css-extract-plugin
export default {"size":"ItemSize_size__K-jZ3"};